import React, { useState } from "react";
import { FaBell, FaCaretDown, FaCheck, FaTimes } from "react-icons/fa";
import logo from "./icons/app_logo.png";
import userAvatar from "./icons/user_avatar.png";
import backgroundImage from "./background.png";
import "./Home.css";
import { useEffect } from "react";
import axios from "axios";

function Subscription() {
  const [selectedNavItem, setSelectedNavItem] = useState("Subscription");
  const [isYearly, setIsYearly] = useState(false);
  const [fadeKey, setFadeKey] = useState(0);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleNavSelect = (navItem) => {
    setSelectedNavItem(navItem);
    console.log("Selected nav item:", navItem);
  };

  const handleToggle = () => {
    setIsYearly(!isYearly);
    setFadeKey((prev) => prev + 1);
  };
  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const res = await fetch(
          "/api/link/links/subscriptions"
        );
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        const data = await res.json();
        setPlans(data);
      } catch (err) {
        console.error("Error fetching subscriptions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  return (
    <div
      className="app"
      style={{
        gridTemplateColumns: "1fr",
        gridTemplateAreas: '"header" "content" "footer"',
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <header className="header">
        <div className="logo">
          <img src={logo} alt="Logo Placeholder" />
        </div>
        <div className="title"></div>
        <nav className="top-nav">
          <a
            className={
              selectedNavItem === "Dashboard" ? "nav-item-selected" : ""
            }
            onClick={() => handleNavSelect("Dashboard")}
          >
            Dashboard
          </a>
          <a
            className={
              selectedNavItem === "Subscription" ? "nav-item-selected" : ""
            }
            onClick={() => handleNavSelect("Subscription")}
          >
            Subscription
          </a>
          <a
            className={
              selectedNavItem === "Help & Support" ? "nav-item-selected" : ""
            }
            onClick={() => handleNavSelect("Help & Support")}
          >
            Help & Support
          </a>
        </nav>
        <div className="account">
          <button className="notification-button">
            <FaBell size={24} color="#7CC644" />
          </button>
          <div className="user-profile">
            <img src={userAvatar} alt="User Profile" className="user-avatar" />
            <FaCaretDown size={16} color="#7CC644" />
          </div>
        </div>
      </header>

      <main
        className="content_home"
        style={{
          gridArea: "content",
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="subscription-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "156px 20px 40px 20px",
            color: "#fff",
            minHeight: "calc(100vh - 200px)",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
              gap: "60px",
              width: "100%",
              maxWidth: "1220px",
            }}
          >
            {loading ? (
              <p style={{ color: "#fff", textAlign: "center" }}>Loading...</p>
            ) : (
              plans.map((plan) => (
                <div
                  key={plan.id}
                  style={{
                    width: "100%",
                    //height: "100%",
                    backgroundColor: "#222",
                    border: "1px solid #444",
                    borderTop:
                      plan.name === "Premium"
                        ? "4px solid #7CC644"
                        : "4px solid #fff",
                    borderRadius: "8px",
                    padding: "48px 16px 36px 16px",
                    display: "flex",
                    flexDirection: "column",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(124, 198, 68, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  {plan.name === "Standard" && (
                    <div
                      style={{
                        position: "absolute",
                        top: "20px",
                        right: "-70px",
                        transform: "rotate(45deg)",
                        backgroundColor: "#7CC644",
                        color: "#000",
                        padding: "10px 90px",
                        fontSize: "12px",
                        fontWeight: "700",
                        letterSpacing: "0.1em",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          transform: "translateX(6px)",
                          display: "inline-block",
                        }}
                      >
                        Popular!
                      </span>
                    </div>
                  )}

                  <h3
                    style={{
                      margin: "0 0 12px 0",
                      fontSize: "24px",
                      color: "#fff",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    {plan.name}
                  </h3>

                  <div
                    key={`price-${fadeKey}`}
                    style={{
                      fontWeight: "bold",
                      color: "#fff",
                      textAlign: "center",
                      margin: "0 0 12px 0",
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "center",
                      animation: "fadeIn 0.4s ease-in-out",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        marginRight: "2px",
                        display: "inline-block",
                        transform: "translateY(-34px)",
                      }}
                    >
                      $
                    </span>
                    <span style={{ fontSize: "64px" }}>
                      {isYearly
                        ? Math.round(parseFloat(plan.price_per_month) * 12)
                        : Math.round(parseFloat(plan.price_per_month))}
                    </span>
                    <span
                      style={{
                        fontSize: "18px",
                        marginLeft: "4px",
                        fontWeight: "600",
                      }}
                    >
                      /{isYearly ? "yr" : "mo"}
                    </span>
                  </div>

                  <p
                    style={{
                      margin: "12px 0 28px 0",
                      color: "#A3E635",
                      fontSize: "14px",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    {plan.description}
                  </p>

                  <ul
                    style={{
                      listStyle: "none",
                      padding: "0 32px",
                      margin: "0 0 28px 0",
                      width: "100%",
                      flex: "1",
                    }}
                  >
                    {Object.entries(plan)
                      .filter(
                        ([k]) =>
                          k.startsWith("access_") ||
                          k.endsWith("support") ||
                          k.endsWith("reports")
                      )
                      .map(([feature, value]) => (
                        <li
                          key={feature}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "16px",
                            marginBottom: "16px",
                          }}
                        >
                          {value ? (
                            <FaCheck
                              style={{ color: "#fff", marginTop: "3px" }}
                              size={18}
                            />
                          ) : (
                            <FaTimes
                              style={{ color: "#666", marginTop: "3px" }}
                              size={18}
                            />
                          )}
                          <span
                            style={{
                              fontSize: "16px",
                              color: value ? "#fff" : "#666",
                              fontWeight: "500",
                            }}
                          >
                            {feature.replaceAll("_", " ")}
                          </span>
                        </li>
                      ))}
                  </ul>

                  <button
                    style={{
                      height: "48px",
                      padding: "0 32px",
                      borderRadius: "50px",
                      border: "none",
                      backgroundColor:
                        plan.name === "Premium" ? "#7CC644" : "#fff",
                      color: plan.name === "Premium" ? "#000" : "#000",
                      fontSize: "16px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    Select {plan.name}
                  </button>
                </div>
              ))
            )}
          </div>

          {/* Billing Toggle */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              marginTop: "48px",
            }}
          >
            <span
              style={{
                color: isYearly ? "#A1A1AA" : "#7CC644",
                fontSize: "16px",
                transition: "color 0.3s ease",
                fontWeight: "500",
              }}
            >
              MONTHLY
            </span>
            <div
              onClick={handleToggle}
              style={{
                width: "60px",
                height: "30px",
                borderRadius: "15px",
                backgroundColor: isYearly ? "#7CC644" : "#444",
                position: "relative",
                cursor: "pointer",
                transition:
                  "background-color 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "3px",
                  left: isYearly ? "33px" : "3px",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  transition: "left 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              />
            </div>
            <span
              style={{
                color: isYearly ? "#7CC644" : "#A1A1AA",
                fontSize: "16px",
                transition: "color 0.3s ease",
                fontWeight: "500",
              }}
            >
              YEARLY
            </span>
          </div>
        </div>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <a>About Us</a>
          <a>Privacy Policy</a>
          <a>Terms of Service</a>
        </div>
      </footer>
    </div>
  );
}

export default Subscription;
